import { ApiAttributionTag, ApiProject } from "@incendium/api";
import { attributionTagService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchAttributionTags = async (project: ApiProject) => {
  const attributionTags = await attributionTagService.attributionTagsServiceListAttributionTags({
    projectId: project.id as number,
  });
  return attributionTags.results || [];
};

export const useAttributionTags = () => {
  const { state, setState } = useProjectSharedState(
    "attributionTags",
    [],
    fetchAttributionTags
  );

  return {
    attributionTags: state as ApiAttributionTag[],
    setAttributionTags: setState,
  };
};
